import { Grid, LinearProgress, Typography } from '@mui/material';

const PauseProgressBar = ({
  label = "Pause Progress",
  current = 0,
  total = 0,
  unit = "Days",
  color = "#f6b500",
}) => {
  const progress = total > 0 ? (current / total) * 100 : 0;

  return (
    <Grid container alignItems="center" spacing={2}>
      {/* Left side (70%) — Label + Progress Bar */}
      <Grid item xs={8.4}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 6,
            borderRadius: 5,
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: color,
            },
          }}
        />
      </Grid>

      {/* Right side (30%) — Dynamic progress text */}
      <Grid item xs={3.6} display={'flex'} justifyContent={'end'}>
        <Typography variant="body2" fontWeight="500" display={'flex'} alignItems={'end'} marginTop='12px'>
          {`${current} of ${total}${unit ? ` ${unit}` : ''}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PauseProgressBar;